<template>
  <div
    class="relative overflow-hidden"
    :style="wrapperStyle"
  >
    <div
      v-if="section.content.backgroundImage"
      class="absolute inset-0 bg-cover bg-center"
      :style="{ backgroundImage: `url(${section.content.backgroundImage})` }"
    />
    <div
      v-if="section.content.backgroundImage"
      class="absolute inset-0"
      :style="{ backgroundColor: section.styles.overlayColor || 'rgba(15, 23, 42, 0.65)' }"
    />

    <div class="relative max-w-4xl mx-auto">
      <h1
        v-if="section.content.headline"
        class="text-4xl md:text-5xl font-bold mb-4"
        :style="{ color: section.styles.headlineColor || '#1f2937' }"
      >
        {{ section.content.headline }}
      </h1>
      <p
        v-if="section.content.subheadline"
        class="text-xl mb-8"
        :style="{ color: section.styles.subheadlineColor || '#6b7280' }"
      >
        {{ section.content.subheadline }}
      </p>
      <div v-if="section.content.ctaText || section.content.secondaryCtaText" class="mt-8 flex flex-wrap items-center justify-center gap-3">
        <a
          v-if="section.content.ctaText"
          :href="section.content.ctaLink || '#'"
          class="inline-block px-8 py-4 rounded-lg font-semibold text-white transition-all hover:opacity-90"
          :style="{ backgroundColor: 'var(--lp-primary-color, #10b981)' }"
        >
          {{ section.content.ctaText }}
        </a>
        <a
          v-if="section.content.secondaryCtaText"
          :href="section.content.secondaryCtaLink || '#'"
          class="inline-block px-8 py-4 rounded-lg font-semibold border transition-all hover:opacity-90"
          :style="secondaryCtaStyle"
        >
          {{ section.content.secondaryCtaText }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    section: { type: Object, required: true },
    preview: { type: Boolean, default: false },
  },
  computed: {
    wrapperStyle() {
      return {
        backgroundColor: this.section.styles.backgroundColor || '#ffffff',
        padding: this.section.styles.padding || '60px 20px',
        textAlign: this.section.styles.textAlign || 'center',
      }
    },
    secondaryCtaStyle() {
      const color = this.section.styles.headlineColor || '#ffffff'
      return {
        borderColor: color,
        color,
      }
    },
  },
}
</script>
